export default "__VITE_ASSET__DFej21Ze__"